const handleOfferBtn = () => {
  const btnSelector = '.offer-btn';
  const listContainerSelector = '.offer-list-container';
  const listSelector = '.offer-list';
  const verticalSignSelector = '.btn__vertical-sign';

  const verticalSignClassToggle = 'show';

  const btnEl = document.querySelector(btnSelector);
  const listContainerEl = document.querySelector(listContainerSelector);
  const listEl = listContainerEl?.querySelector(listSelector);
  const verticalSignEl = btnEl?.querySelector(verticalSignSelector);

  const foundAllEl =
    btnEl != null &&
    verticalSignEl != null &&
    listContainerEl !== null &&
    listEl !== null;

  const handleMedia = ({ matches }) => {
    if (matches) {
      listContainerEl?.removeAttribute('style');
    }
  };

  if (foundAllEl) {
    const handleClick = () => {
      const listHeight = listEl.clientHeight;
      const listContainerHeight = listContainerEl.clientHeight;

      verticalSignEl.classList.toggle(verticalSignClassToggle);

      listContainerEl.style.height =
        listContainerHeight === 0 ? `${listHeight}px` : `${0}px`;
    };

    const media = window.matchMedia('(min-width: 768px)');

    btnEl.addEventListener('click', handleClick);
    media.addEventListener('change', handleMedia);
  }
};
export default handleOfferBtn;
